<template>
	<div v-loading="loading">
		<div id="wrap" class="fixed handleClick">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="企业信息" name="first"></el-tab-pane>
				<el-tab-pane label="经济效益" name="second"></el-tab-pane>
				<el-tab-pane label="专业化程度" name="third"></el-tab-pane>
				<el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
				<el-tab-pane label="经营管理" name="six"></el-tab-pane>
				<el-tab-pane label="资料生成" name="seven"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="wrap_page">申报资料生成</div>

		<div class="content" style="margin-top:30px;">
			<el-steps align-center>
				<el-step :status="first" title="企业信息" description=""></el-step>
				<el-step :status="second" title="经济效益" description=""></el-step>
				<el-step :status="third" title="专业化程度" description=""></el-step>
				<el-step :status="fourth" title="创新能力" description=""></el-step>
				<el-step :status="fifth" title="经营管理" description=""></el-step>
				<el-step
					title="资料生成"
					description="生成资料24h后登录系统下载"
				></el-step>
			</el-steps>
		</div>
		<div class="flex flex-center" style="margin-top:100px;">
			<el-button type="primary" :disabled="disable" @click="generate()"
				>申请生成申报资料</el-button
			>
		</div>
		<div class="flex flex-center" style="margin-top:100px;">
			<span
				>申请后,系统将自动处理生成,生成结果请24小时后回到系统专精特新立项列表查看</span
			>
		</div>
	</div>
</template>

<script>
import { getDataGenerated, generatePDF } from "@/api/specialization";
import { commonSubmitGenerateApproval } from "@/api/toolCommon";
export default {
	data() {
		return {
			obj: { objectId: "", type: 2 },
			loading: false,
			activeName: "seven",
			first: "wait",
			second: "wait",
			third: "wait",
			fourth: "wait",
			fifth: "wait",
			disable: false
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			getDataGenerated(sessionStorage.getItem("zt_special_id")).then(res => {
				if (res.data.degreeSpecializationMaterialGenerateState == 1) {
					this.third = "finish";
				} else {
					this.disable = true;
				}
				if (res.data.innovationAbilityMaterialGenerateState == 1) {
					this.fourth = "finish";
				} else {
					this.disable = true;
				}
				if (res.data.operatingManagementMaterialGenerateState == 1) {
					this.fifth = "finish";
				} else {
					this.disable = true;
				}
				if (res.data.projectMaterialGenerateState == 1) {
					this.first = "finish";
				} else {
					this.disable = true;
				}
				if (res.data.stateOperationMaterialGenerateState == 1) {
					this.second = "finish";
				} else {
					this.disable = true;
				}
			});
		},
		handleClick(tab, event) {
			if (tab.index == 0) {
				this.$router.push("/centerform/specializationRegistration");
			} else {
				console.log(sessionStorage.getItem("zt_special_id"));
				if (
					sessionStorage.getItem("zt_special_id") == "undefined" ||
					sessionStorage.getItem("zt_special_id") == null ||
					sessionStorage.getItem("zt_special_id").length != 32
				) {
					// if (false){
					this.msgError("请先保存企业信息,保存后才可继续填写其它数据");
				} else {
					if (tab.index == 1) {
						this.$router.push("/centerform/specializationBenefit");
					} else if (tab.index == 2) {
						this.$router.push("/centerform/specializationProfessionalization");
					} else if (tab.index == 3) {
						this.$router.push("/centerform/specializationInnovationCapacity");
					} else if (tab.index == 4) {
						this.$router.push("/centerform/specializationManagement");
					} else if (tab.index == 5) {
						this.$router.push("/centerform/specializationDatagenerated");
					}
				}
			}
		},
		generate() {
            this.obj.objectId = sessionStorage.getItem("zt_special_id");
            commonSubmitGenerateApproval(this.obj).then(res => {
                if (res.code == "00000") {
                    this.$alert("提交申请成功,预计" + res.data + "后完成生成", {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.push("projectapproval")
                        }
                    })
                }
            });
            // this.$router.push("/specialization/projectapproval")

		}
	}
};
</script>
<style scoped>
</style>
